import classNames from 'classnames';
import React from 'react';
import EfImgVideo from '../ef-img-video';
import './index.scss';

interface EfSectionLRProps {
    /**
     * 资源链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;
    /**
     * label
     */
    label?: React.ReactNode;
    /**
     * 主标题
     */
    title?: React.ReactNode;
    /**
     * 描述
     */
    desc?: React.ReactNode;

    /**
     * 图片摆放位置
     */
    position?: 'imgR' | 'imgL';

    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 段落--左右布局
 */
const EfSectionLR: React.FC<EfSectionLRProps> = ({ isVideo, pc, h5, poster, posterH5, title, label, desc, position, className }) => {
    const prefixCls = `ef-section-l-r`;
    const hasImg = pc || h5;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
        [`${prefixCls}-position-${position}`]: position,
    });

    return (
        <div className={classes}>
            <div className={`${prefixCls}-in`}>
                <div className={`${prefixCls}-msg`}>
                    {label && <div className={`${prefixCls}-label`}>{label}</div>}
                    {title && <h2 className={`${prefixCls}-title`}>{title}</h2>}
                    {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                </div>
                {hasImg && (
                    <div className={`${prefixCls}-img`}>
                        <EfImgVideo isVideo={isVideo} pc={pc} h5={h5} poster={poster} posterH5={posterH5} autoPlay={true} loop={true} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default EfSectionLR;
